/* eslint-disable no-tabs */
import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import LotteryBaseLayout from './containers/Layouts/LotteryBaseLayout'
import { RoutesConstant } from './util/constants'
import AppContextProvider from './context/AppContextProvider'
import ModalContextProvider from './context/ModalContextProvider'
import AuthContextProvider from './context/AuthContextProvider'
import MessageHandlerContextProvider from './context/MessageHandlerContextProvider'

const App = () => {
  return (
    <Router>
      <MessageHandlerContextProvider>
        <AuthContextProvider>
          <AppContextProvider>
            <ModalContextProvider>
              <Switch>
                <Route
                  path={RoutesConstant.HOME_ROUTE}
                  render={props => <LotteryBaseLayout {...props} />}
                />
              </Switch>
            </ModalContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
      </MessageHandlerContextProvider>
    </Router>
  )
}

export default App
